import { useRouter } from 'next/router'

import { useStatsigDynamicLocaleConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-locale-config.hook'

import { isBannerDisabledRoute } from './cookie-banner.utils'

const CookieBanner = () => {
  // TrustArc CCM is now enabled for all users.
  const { asPath } = useRouter()
  const { consentBannerDisabledRoutes } = useStatsigDynamicLocaleConfig()
  const hideBanner = isBannerDisabledRoute(asPath, consentBannerDisabledRoutes)

  // Keep `#consent_blackbar` mounted so TrustArc always has its banner container and the
  // consent machinery (cookies, CMA API, footer "Cookie Preferences" link) is unchanged.
  // On routes listed in the locale config (e.g. UK `/privacy-policy`) we only hide the bar
  // so the auto-banner never shows there. `asPath` + the locale config are both serialized
  // into __NEXT_DATA__, so this evaluates identically on the server and on hydration.
  return <div id="consent_blackbar" style={hideBanner ? { display: 'none' } : undefined}></div>
}

export default CookieBanner
